import { Avatar, AvatarFallback, AvatarImage } from "./avatar";
import { cn } from "@drpcrd/utils/shared";
import { formatCdnImg } from "@drpcrd/utils/formatters";
import { DefaultCampaignLogo } from "./icons";

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-8 w-8",
};

type Props = {
  logoUrl?: string | null;
  altText?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

/**
 * Logo avatar component using shadcn Avatar with PartyPopper fallback.
 * Used across applications for consistent entity logo display.
 */
export const LogoAvatar = ({
  logoUrl,
  altText = "Logo",
  size = "md",
  className,
}: Props) => (
  <Avatar className={cn(sizeClasses[size], className)}>
    {logoUrl && (
      <AvatarImage
        src={logoUrl.startsWith("http") ? logoUrl : formatCdnImg(logoUrl)}
        alt={altText}
      />
    )}
    <AvatarFallback className="bg-neutral-200">
      <DefaultCampaignLogo className="h-2 w-2" />
    </AvatarFallback>
  </Avatar>
);
